import { SelectItem } from 'primeng/api';
import { Gender } from '../enums';

export class GenderLookup {
    static getLookup(): SelectItem[] {
        return [
            { label: 'Male', value: Gender.Male },
            { label: 'Female', value: Gender.Female },
        ]
    }

    static getLookupWithAll(): SelectItem[] {
        return [
            { label: 'All', value: null },
            { label: 'Male', value: Gender.Male },
            { label: 'Female', value: Gender.Female },
        ]
    }

    static selectGenderLookUp(): SelectItem[] {
        return [
            { label: 'Select Gender', value: null },
            { label: 'Male', value: Gender.Male },
            { label: 'Female', value: Gender.Female },
        ]
    }
}
